import { Component, Input, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { examDefault } from 'src/app/interface/dtoDefaults';
import { PopoverRef } from 'src/@vex/components/popover/popover-ref';
import { IExam, IExamCategory, IUploadQuestion, UploadContext } from 'src/app/interface/dto';
import { ServiceResponse } from 'src/app/models/service-response';
import { ExamService } from 'src/app/services/exam-service.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { QuestionBankService } from 'src/app/questions-bank/question-bank.service';

@Component({
  selector: 'app-upload-questions',
  templateUrl: './upload-questions.component.html',
  styleUrls: ['./upload-questions.component.scss']
})
export class UploadQuestionsComponent implements OnInit {
  context: UploadContext = UploadContext.Exam;

  parentEntity: any = null;
  parentName: string = '';

  modelError = '';
  upQues: IUploadQuestion = {
    id: 0,
    file: undefined,
    encoding: 'Default',
    isNegativeMark: false,
    isHtml: false,
    category: ''
  };
  categoryList: IExamCategory[] = [];

  constructor(private popoverRef: PopoverRef<UploadQuestionsComponent>,
    private examsevice: ExamService, 
    private questionBankService: QuestionBankService,
    private snackBar: SnackbarService,) { 
      const data = this.popoverRef.data as { context?: UploadContext };
      if (data?.context) {
        this.context = data.context;
      }
    }

  get isExamContext(): boolean {
    return this.context === UploadContext.Exam;
  }

  async ngOnInit() {
    await this.initializeComponent();
  }

  private async initializeComponent() {
    if (this.isExamContext) {
      await this.initializeForExam();
    } else {
      await this.initializeForQuestionBank();
    }
  }

  private async initializeForExam() {
    if (this.examsevice.selectedExams.length === 1) {
      this.parentEntity = this.examsevice.selectedExams[0];
      this.parentName = this.parentEntity.examinationName;
      await this.examsevice.getExamCategories(this.parentEntity.id).then((categories: any) => {
        this.categoryList = categories;
      });
    }
  }

  private async initializeForQuestionBank() {
    if (this.questionBankService.selectedQuestionBanks.length === 1) {
      this.parentEntity = this.questionBankService.selectedQuestionBanks[0];
      this.parentName = this.parentEntity.name;
      await this.examsevice.getQuestionCategories().then((c: any) => {
        this.categoryList = c.map((cat: string) => ({
          category: cat,
          id: 0,
          examinationID: 0,
          numberOfQuestions: 0,
          instruction: '',
          maximumNumberOfEssayAnswers: 0,
          maximumNumberOfSAQAnswers: 0
        } as IExamCategory));
      });
    }
  }

  get isQuestionBankContext(): boolean {
    return this.context === UploadContext.QuestionBank;
  }

  get uploadTitle(): string {
    return this.isExamContext 
      ? `Upload Questions for ${this.parentName}` 
      : `Upload Questions to ${this.parentName}`;
  }


  onQuestionFileChange(event: any) {

    if (event.target.files && event.target.files[0]) {
      this.upQues.file = event.target.files[0];
    }
  }

  close() {
    this.popoverRef.close();
  }

   async uploadQuestion() {
    this.modelError = '';
    this.validateModel();
    
    if (this.modelError !== '') {
      return;
    }

    const formData = this.buildFormData();

    try {
      if (this.isExamContext) {
        await this.uploadExamQuestions(formData);
      } else {
        await this.uploadQuestionBankQuestions(formData);
      }
    } catch (error) {
      this.snackBar.error('Upload failed. Please try again.');
      console.log('Error:'+ error);
    }
  }

  private buildFormData(): FormData {
    const formData = new FormData();
    
    if (this.isExamContext) {
      formData.append('examinationID', '' + this.parentEntity.id);
    } else {
      formData.append('questionBankID', '' + this.parentEntity.id);
    }
    
    formData.append('encoding', this.upQues.encoding);
    formData.append('category', this.upQues.category);
    formData.append('isNegativeMark', '' + this.upQues.isNegativeMark);
    formData.append('isHtml', '' + this.upQues.isHtml);
    formData.append('file', this.upQues.file!);
    
    return formData;
  }

  private async uploadExamQuestions(formData: FormData) {
    await this.examsevice.uploadExamQuestions(formData).then((s: any) => {
      this.snackBar.success(`Questions uploaded successfully.`);
      this.close();
    });
  }

  private async uploadQuestionBankQuestions(formData: FormData) {
    await this.questionBankService.uploadQuestionBankQuestions(formData).then((s: any) => {
      this.snackBar.success(`Questions uploaded successfully.`);
      this.close();
    });
  }

  validateModel() {
    if (this.upQues.encoding == '') {
      this.modelError += "\n*Encoding required\n"
    } if (this.upQues.file == undefined) {
      this.modelError += "\n*File required\n"
    } 
  }
}
